import { Button, Col, Row } from 'antd'
import React from 'react'
import LibraryScheduledTable from './components/LibraryScheduledTable';
import './LibraryScheduled.css'

const LibraryScheduled = () => {
    return (
        <div className="page-container-library-schedule">
            {/* <div className="main-container"> */}
                <Row gutter={[0, 12]}>

                    <Col span={24} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h1 className='page-heading-library-schedule'>Scheduled</h1>
                    </Col>


                    <Col span={24} style={{ margin: '20px 0px' }}>
                        <LibraryScheduledTable />
                    </Col>


                </Row>

             </div>
    )
}

export default LibraryScheduled;
